import { TakeawayStoresGridView } from '~/components/order/takeaway-stores/grid';
import { PageContainer } from '~/components/page-container';

export function TakeawayStores() {
	return (
		<PageContainer>
			<TakeawayStoresGridView />
		</PageContainer>
	);
}
